export const RETURN_REASONS = [ // do not expose certain codes per mafia request (backend doesn't currently work)
  {
    text: 'Select a reason', // default/no reply
    amznKey: 'CR-UNWANTED_ITEM',
    reasonCode: '18'
  },
  {
    text: 'Did not fit',
    amznKey: 'NOT_COMFORTABLE',
    reasonCode: '292'
  },
  {
    text: 'Unhappy with style',
    amznKey: 'AMZ-PG-APP-STYLE',
    reasonCode: '203'
  },
  // {
  //   text: 'Unhappy with color',
  //   amznKey: 'DID_NOT_LIKE_COLOR',
  //   reasonCode: '207'
  // },
  {
    text: 'Received wrong merchandise',
    amznKey: 'CR-SWITCHEROO',
    reasonCode: '15'
  },
  {
    text: 'Received defective merchandise',
    amznKey: 'CR-DEFECTIVE',
    reasonCode: '16'
  },
  {
    text: 'Found better price elsewhere',
    amznKey: 'CR-FOUND_BETTER_PRICE',
    reasonCode: '2'
  }
  // {
  //   text: 'Received extra item I didn\'t buy (no refund)',
  //   amznKey: 'CR-EXTRA_ITEM',
  //   reasonCode: '17'
  // }
];
